// extracted by mini-css-extract-plugin
export default {"wrap":"MobilePanel_wrap__mB6gu","logo":"MobilePanel_logo__oqCdi"};